import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.scss';

const Button = ({
					name = Math.random().toString(36).substring(7),
					value,
					type = 'button',
					onClick,
					className = '',
					classNameConcat = '',
					layout = '',
					disabled,
					ariaLabel,
					title,
					id,
					testId,
					analyticsType,
					analyticsPositionIndex,
					analyticsText
				}) => {
	let classNameInner = className || (layout ? styles[layout] : styles.default);
	if (classNameConcat) classNameInner += ` ${classNameConcat}`;

	if (!analyticsText) {
		analyticsText = value;
	}

	return (
	  <button
		type={type}
		name={name}
		onClick={onClick}
		className={classNameInner}
		id={id}
		disabled={disabled}
		title={title}
		data-test={testId}
		aria-label={ariaLabel}
		data-elements-text={analyticsText}
		data-elements-content={analyticsType}
		data-elements-position={analyticsPositionIndex}>
		  <span>{value}</span>
	  </button>
	);
};

Button.propTypes = {
	name: PropTypes.string,
	onClick: PropTypes.func,
	value: PropTypes.string,
	type: PropTypes.string,
	className: PropTypes.string,
	classNameConcat: PropTypes.string,
	layout: PropTypes.string,
	id: PropTypes.string,
	testId: PropTypes.string,
	ariaLabel: PropTypes.string,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	analyticsText: PropTypes.string,
	analyticsPositionIndex: PropTypes.number,
	analyticsType: PropTypes.string,
};

export default Button;
